import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import { familialRelationKeyMaker, getFamilialRelation, } from "../requests/getFamilialRelation";
const useGetFamilialRelation = makeDoubleArgHook(getFamilialRelation, (clientId, familialRelationId) => familialRelationKeyMaker(clientId, familialRelationId));
export default useGetFamilialRelation;
//# sourceMappingURL=useGetFamilialRelation.js.map